import * as constants from './constants'
import { fromJS } from 'immutable'
import { combineReducers } from 'redux-immutable'
import Cookies from 'js-cookie'
import { reducer as deviceReducer } from '../pages/device/store'
import { reducer as cameraReducer } from '../pages/camera/store'
import { TOKEN_KEY } from '../constants'

const defaultState = fromJS({
  menuCollapsed: false,
  isLogin: true,
  allEnum: {},
  loginUser: {}, // 登录用户信息
  personalize: {}, // 用户个性化配置
  breadcrumb: [], // 二级页面导航面包屑
  balance: 0 // 用户余额
})

const reducer = (state = defaultState, action) => {
  const { type, value } = action
  switch (type) {
    case constants.MENU_COLLAPSED:
      return state.set('menuCollapsed', !state.get('menuCollapsed'))
    case constants.CHANGE_LOGIN_STATUS:
      if (!value) {
        Cookies.remove(TOKEN_KEY)
      }
      return state.set('isLogin', value)
    case constants.SET_ALL_ENUM:
      return state.set('allEnum', value)
    case constants.SET_LOGIN_USER:
      return state.set('loginUser', value)
    case constants.SET_PERSONALIZE:
      return state.set('personalize', value)
    case constants.SET_BREADCRUMB:
      return state.set('breadcrumb', value)
    case constants.SET_BALANCE:
      return state.set('balance', value)
    default:
      return state
  }
}

export default combineReducers({
  common: reducer,
  device: deviceReducer,
  camera: cameraReducer
})
